import ConsultingReport from 'components/consulting-report';

const GuestConsultingReportDetail = () => {
  return <ConsultingReport authorType={'guest'} />;
};

export default GuestConsultingReportDetail;
